var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38791",
    "data-name": "Path 38791",
    d: "M125.214,128.429h-10A3.214,3.214,0,0,1,112,125.214v-10A3.214,3.214,0,0,1,115.214,112h10a3.214,3.214,0,0,1,3.214,3.214v10A3.214,3.214,0,0,1,125.214,128.429Z",
    transform: "translate(-76.429 -76.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38792",
    "data-name": "Path 38792",
    d: "M37.714,34.143h10.53A3.22,3.22,0,0,0,45.214,32h-10A3.214,3.214,0,0,0,32,35.214v10a3.22,3.22,0,0,0,2.143,3.03V37.714A3.571,3.571,0,0,1,37.714,34.143Z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c3b99b4a.svg";
export { ForwardRef as ReactComponent };